var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.list ? _c("div", {
    staticClass: "ProductListSlider"
  }, [_vm.title ? _c("h4", {
    style: {
      color: _vm.titleColor
    }
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _c("div", {
    staticClass: "sliderContent",
    style: {
      height: _vm.height + "px"
    }
  }, [_vm.list.length > 5 ? _c("div", {
    staticClass: "SliderLeft",
    on: {
      click: _vm.left
    }
  }, [_c("i", {
    staticClass: "yy-icon-ArrowLeft"
  })]) : _vm._e(), _c("dd", {
    ref: "Slider_box",
    staticClass: "Slider_box",
    style: "transform:translate3d(".concat(_vm.sleder, "px, 0px, 0px)")
  }, _vm._l(_vm.list, function (item, key) {
    return _c("dl", {
      key: key
    }, [_c("productItem", {
      attrs: {
        productDetail: item,
        addCartBgColor: _vm.addCartBgColor
      },
      on: {
        addCartHandle: _vm.addCartHandle
      }
    })], 1);
  }), 0), _vm.list.length > 5 ? _c("div", {
    staticClass: "SliderRight",
    on: {
      click: _vm.right
    }
  }, [_c("i", {
    staticClass: "yy-icon-ArrowRight"
  })]) : _vm._e()])]) : _vm._e();
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };